// Module
var code = "<el-row type=\"flex\" justify=\"center\"> <el-col :md=\"8\"> <el-alert :title=\"title\" type=\"error\" :closable=\"false\" description=\" \" show-icon> </el-alert> </el-col> </el-row> ";
// Exports
module.exports = code;